<template>
  <div class="info-base-detail">
    <img class="detail-img" :src="bannerObj.image" height="305" />
    <div class="detail-content">
      <a-breadcrumb>
        <span slot="separator">
          <img src="~@/assets/img/detail-arrow.svg" style="margin: 0 6px" />
        </span>
        <a-breadcrumb-item href="">
          <img src="~@/assets/img/home.png" class="home-class" />
          <span style="color: #333">首页</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item href="">
          <span style="color: #333">信息库</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <span style="color: #7f7f7f">国家级工美大师</span>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="btn-wrapper clearfix">
        <div class="btn">
          <input type="text" v-model="params.keyword" />
          <span @click="artInfoBaseListFunc"></span>
        </div>
      </div>
      <div class="tabs">
        <span
          v-for="tab of tabsList"
          :key="tab.id"
          :class="{ tabActive: tab.id === tabActive }"
          @click="handleClickActive(tab.id)"
          >{{ tab.name }}</span
        >
      </div>
      <div class="tabs-content">
        <span
          v-for="item in contentList"
          :key="item.id"
          @click="handleClickToExpertDetail(item)"
          >{{ item.fullName }}</span
        >
      </div>
      <div class="tabs-page">
        <em @click="changePage(false)">
          上一篇
          <img src="@/assets/img/arrow-l.png" alt="" />
        </em>
        <span>{{ params.page }}</span
        >/<span>{{ totalPage }}</span>
        <em @click="changePage(true)">
          <img src="@/assets/img/arrow-r.png" alt="" />
          下一篇
        </em>
      </div>
    </div>
  </div>
</template>

<script>
import { artBannerList } from "@/api/ExpertThinkTank";
import { artDictCategory, artInfoBaseList,artInfoBaseDetail } from "@/api/InfoBase";

export default {
  name: "Detail",
  data() {
    return {
      tabActive: 0,
      bannerObj: {},
      tabsList: [],
      contentList: [],
      totalPage: null,
      params: {
        limit: 35,
        page: 1,
        dictType: "guojiadashi",
        sortName: null,
        keyword: "",
      },
      categoryParams: {
        category: "guojiadashi",
      },
    };
  },
  mounted() {
    this.artBannerListFunc();
    this.artDictCategoryFunc();

    this.artInfoBaseListFunc();
  },
  methods: {
    handleClickToExpertDetail(task) {
      this.$router.push({
        path: "InfoDetail",
        query: {
          id: task.id,
        },
      });
    },
    changePage(flag) {
      // 下一页
      if (flag) {
        if (this.params.page === this.totalPage) {
          return;
        }
        this.params.page = this.params.page + 1;
      } else {
        if (this.params.page === 1) {
          return;
        }
        this.params.page = this.params.page - 1;
      }
      this.artInfoBaseListFunc();
    },
    handleClickActive(id) {
      if (id === this.tabActive) return;
      this.tabActive = id;
      this.params.page = 1;
      this.params.sortName = id;
      this.artInfoBaseListFunc();
    },
    artBannerListFunc() {
      artBannerList({
        area: 4,
      })
        .then((res) => {
          this.bannerObj = res.data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    artDictCategoryFunc() {
      artDictCategory(this.categoryParams)
        .then((res) => {
          console.log(res);
          this.tabsList = res.data;
          this.tabActive = this.params.sortName = res.data[0].id;
          this.artInfoBaseListFunc();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    artInfoBaseListFunc() {
      artInfoBaseList(this.params)
        .then((res) => {
          console.log(res);
          this.contentList = res.data;
          this.totalPage = res.totalPage;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.info-base-detail {
  .detail-img {
    width: 100%;
    height: 305px;
  }
  .detail-content {
    margin: 0 auto;
    width: 1240px;
    .ant-breadcrumb {
      line-height: 14px;
      margin: 84px 0 0;
    }
    .home-class {
      width: 14px;
      height: 14px;
      vertical-align: top;
      margin-right: 2px;
    }
    .btn-wrapper {
      margin-bottom: 16px;
      .btn {
        float: right;
        width: 398px;
        height: 32px;
        input {
          float: left;
          padding: 0;
          width: 368px;
          height: 32px;
          border: 1px solid #aaa;
          border-right-color: transparent;
          text-indent: 12px;
        }
        span {
          float: left;
          width: 28px;
          height: 32px;
          background: #2d3f51 url("../../../assets/img/search.png") no-repeat center;
          background-size: 13px 14px;
        }
      }
    }
    .tabs {
      margin-bottom: 10px;
      height: 56px;
      line-height: 51px;
      border-bottom: 1px solid #dbdbdb;
      display: flex;
      justify-content: left;
      span {
        margin-right: 48px;
        line-height: 41px;
        font-size: 18px;
        position: relative;
        cursor: pointer;
      }
      span.tabActive {
        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 71px;
          height: 4px;
          background: #2d3f51;
        }
      }
    }
    .tabs-content {
      padding: 0 22px;
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      span {
        line-height: 90px;
        width: 80px;
        margin-right: 198px;
        font-size: 15px;
        color: #333;
      }
      span:nth-of-type(5n) {
        margin-right: 0;
        text-align: right;
      }
    }
    .tabs-page {
      padding: 24px 0 73px;
      text-align: center;
      user-select: none;
      em {
        cursor: pointer;
      }
      img {
        width: 46px;
        height: 35px;
        margin: 0 19px;
      }
      span {
        font-size: 15px;
      }
      span:nth-of-type(1) {
        margin-right: 6px;
        color: #2d3f51;
      }
      span:nth-of-type(2) {
        margin-left: 6px;
        color: #aaa;
      }
    }
  }
}
</style>
